import type { Middleware, Tuple } from '@reduxjs/toolkit'
import { configureStore } from '@reduxjs/toolkit'
import { gqlClient } from 'gql'

import { notify } from 'components/uiKit/Notification'
import { lmsMiddleware } from 'services/lms/middleware/lms.middleware'

// import { SCORM_API_Wrapper } from 'scormWrapper/vendors/SCORM_API_Wrapper'
import { blockPatch } from './Project/middlewares/blockPatch'
import { employeePreferences } from './Project/middlewares/employeePreferences'
import { localStorage } from './Project/middlewares/localStorage'
import { logger } from './Project/middlewares/logger'
import { navigation } from './Project/middlewares/navigation'
import { scroll } from './Project/middlewares/scroll'
import projectReducer from './Project/reducer'
import preferencesMiddleware from './Users/preferencesMiddleware'
import usersReducer from './Users/reducer'

const store = configureStore({
  reducer: {
    project: projectReducer,
    users: usersReducer,
  },

  middleware: (getDefaultMiddleware) =>
    [
      ...getDefaultMiddleware(),
      lmsMiddleware,
      blockPatch({ client: gqlClient.core, notify }),
      scroll,
      localStorage,
      navigation,
      preferencesMiddleware,
      employeePreferences,
      logger,
    ] as Tuple<Middleware[]>,
})

export default store
